import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-BDesign";
import leftimgs from "../../../assets/adobeleftimg.png";
import rightimgs from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/Kidprenur-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/Kidprenur-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/Kidprenur-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/Kidprenur-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/Kidprenur-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/Kidprenur-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/Kidprenur-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/Kidprenur-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/Kidprenur-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/KidprenurFun-img1.png";
import FunactivitiesImg2 from "../../../assets/KidprenurFun-img2.png";
import FunactivitiesImg3 from "../../../assets/KidprenurFun-img3.png";
import FunactivitiesImg4 from "../../../assets/KidprenurFun-img4.png";
import FunactivitiesImg5 from "../../../assets/KidprenurFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const foundationModules = [
    {
      title: "Module 1",
      activities: "03",
      classes: "03",
      description:
        "Develop Your Big Business Idea- Kids explore different business ideas and learn how to turn their passions into a small business.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "04",
      description: "  Make a Business Plan- Students clarify their ideas, define their target audience, and identify their Unique Selling Point (USP) to build a clear action plan.",
    },
    {
      title: "Module 3",
      activities: "03",
      classes: "03",
      description: "  Design Your Brand-Kids create a brand name and design their logo using Canva, building a visual identity for their business.",
    },
    {
      title: "Module 4",
      activities: "05",
      classes: "05",
      description: " Make Marketing Magic-Kids learn marketing basics, design ads in Canva, and set up a Facebook Business Suite account to promote",
    },
  ];

  const benefitsData = [
      {
        title: "Entrepreneurship Basics",
        description: "Learn the core concepts of entrepreneurship in a fun and simple way.",
        icon: "Polymath-images/Kidprenur-benefit-img1.png", //ji
      },
      {
        title: "Idea Generation",
        description: "Discover how hobbies and passions can become real business ideas.",
        icon: "Polymath-images/Kidprenur-benefit-img2.png",
      },
      {
        title: "Business Planning",
        description: "Create a step-by-step action plan to bring ideas to life.",
        icon: "Polymath-images/Kidprenur-benefit-img3.png",
      },
      {
        title: "Target Audience",
        description: "Understand who your customers are and what they need.",
        icon: "Polymath-images/Kidprenur-benefit-img4.png",
      },
      {
        title: "Unique Selling Proposition (USP)",
        description: "Learn how to stand out with a unique idea or feature.",
        icon: "Polymath-images/Kidprenur-benefit-img5.png",
      },
      {
        title: "Branding",
        description: "Choose a business name and design your own logo using Canva.",
        icon: "Polymath-images/Kidprenur-benefit-img6.png",
      },
      {
        title: "Marketing Magic",
        description: "Explore smart strategies to promote your business idea.",
        icon: "Polymath-images/Kidprenur-benefit-img7.png",
      },
      {
        title: "Creating Ads & Visuals",
        description: "Design fun and eye-catching marketing materials.",
        icon: "Polymath-images/Kidprenur-benefit-img8.png",
      },
      {
        title: "Using Facebook Business Tools",
        description: "Set up a Facebook Business Suite account to share your brand.",
        icon: "Polymath-images/Kidprenur-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "USP",
          image: "Polymath-images/KidprenurFun-img1.png",
        },
        {
          title: "BrainStorm Ideas",
          image: "Polymath-images/KidprenurFun-img2.png",
        },
        {
          title: "Logo Designing",
          image: "Polymath-images/KidprenurFun-img3.png",
        },
        {
          title: "Marketing Basics",
          image: "Polymath-images/KidprenurFun-img4.png",
        },
        {
          title: "Facebook Store",
          image: "Polymath-images/KidprenurFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const Kidprenur = () => {
  const KidPrenurpage = heroContent.kidprenursection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={"Polymath-images/adobeleftimg.png"}
      rightImg={"Polymath-images/adoberightimg.png"}
      titlePart1="Kidprenur"
      titlePart2="Course"
      description="Learning to become an entrepreneur does not only involve starting a business venture. It involves learning a skillset such as thinking BIG, being creative and innovative, identifying and solving problems, communication, research, planning and leadership."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={foundationModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Kidprenur;